function initBannerScripts() {
  console.log("run start");

  const $section1 = $(".shopify-section.section:has(.Givonate-Widget)");
  const $section2 = $(".custom-image-gallery-section");
  if (!$section1.length && !$section2.length) return;

  // Top offsets
  const defaultTop = 9.375;
  const stickyTop = 6.25;
  const defaultBottom = 41.583;
  const stickyBottom = 36.458;

  function updateTop() {
    if ($(window).scrollTop() > 0) {
      if ($section1.length) $section1.css("top", stickyTop + "vw");
      if ($section2.length) $section2.css("top", stickyBottom + "vw");
    } else {
      if ($section1.length) $section1.css("top", defaultTop + "vw");
      if ($section2.length) $section2.css("top", defaultBottom + "vw");
    }
  }

  updateTop();
  $(window).off("scroll.initTop").on("scroll.initTop", updateTop);

  const $title = $(
    ".shopify-section.gaza-multi:has(.build-hope) .multicolumn__title",
  );

  // if ($title.length && !$title.next("p.custom-text").length) {
  //   $title.after(
  //     '<p class="custom-text">Help build and support a life-saving camp for displaced families in Central Gaza. Your generosity provides food, clean water, hygiene, and safe shelter.</p>',
  //   );
  // }

  // const $label = $(
  //   ".shopify-section.section:has(.Givonate-Widget) .Givonate-Checkbox-label__feature",
  // );
  // if ($label.length && !$label.next("div.Givonate-custom-text").length) {
  //   $label.after(
  //     '<div class="Givonate-custom-text">⚡ 100% Zakat — Every penny reaches Gaza</div>',
  //   );
  // }

  // ─────────────────────────────────────────────────────────────
  // Widget footer + toggle buttons
  // ─────────────────────────────────────────────────────────────
  const $widget = $(
    ".shopify-section.section:has(.Givonate-Widget) .Givonate-Widget-amounts",
  );

  if ($widget.length && !$widget.data("footer-added")) {
    // Footer quote
    $widget.after(
      '<div class="Givonate-footer-text">"Whoever saves a life, it is as if they saved all of humanity"</div>',
    );

    // Trust badges
    $widget.after(
      '<div class="Givonate-custom-footer"><span class="trust-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>256-bit Secure</span><span class="trust-badge"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>Tax Deductible</span></div>',
    );

    if (currentPageId == 155838120243) {
      var onetimetext = "Fidya";
      var monthtext = "KAFFARAH";
    } else {
      var onetimetext = "One-time Donation";
      var monthtext = "Monthly Support";
    }

    // ─── Toggle buttons ────────────────────────────────────────
    if (!$widget.data("toggle-added")) {
      $widget.data("toggle-added", true);

      const toggleHtml = `
          <div class="toggle_btns">
          <div class="slide-bg"></div>
            <button class="toggle_btn toggle_btn_active"> 💛 ${onetimetext} </button>
            <button class="toggle_btn monthlybtn">💙 ${monthtext}</button>
          </div>
        `;

      // Add at the very top of .Givonate-Widget-amounts
      $widget.prepend(toggleHtml);

      // Basic active state toggle (you can expand this later)
      $widget.find(".toggle_btn").on("click", function () {
        $widget.find(".toggle_btn").removeClass("toggle_btn_active");
        $(this).addClass("toggle_btn_active");

        // Optional: future logic example
        // const isOneTime = $(this).text().includes('One-time');
        // $('.Givonate-Widget-amount').toggle(isOneTime);
        // $('.shopify_subscriptions_app_container').toggle(!isOneTime);
      });
    }
    // ───────────────────────────────────────────────────────────

    // Mark footer as added
    $widget.data("footer-added", true);
  }

  // Move gallery after footer
  const $section = $(".custom-image-gallery-section");
  const $footer = $(
    ".shopify-section.section:has(.Givonate-Widget) .Givonate-Widget-footer",
  );
  if ($section.length && $footer.length && !$section.data("moved")) {
    $section.insertAfter($footer);
    $section.data("moved", true);
  }

  // Countdown
  $(".dd-countdown__timer").each(function () {
    var $timer = $(this);
    if ($timer.data("countdown-initialized")) return; // prevent duplicate intervals

    var endDate = new Date($timer.data("end")).getTime();

    function updateCountdown() {
      var now = new Date().getTime();
      var diff = endDate - now;
      if (diff < 0) diff = 0;

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      $timer.find(".dd-days").text(days);
      $timer.find(".dd-hours").text(("0" + hours).slice(-2));
      $timer.find(".dd-minutes").text(("0" + minutes).slice(-2));
      $timer.find(".dd-seconds").text(("0" + seconds).slice(-2));
    }

    updateCountdown();
    var interval = setInterval(updateCountdown, 1000);
    $timer.data("countdown-initialized", interval);
  });

  const labels = window.pagesDonationLabels || [];
  const popularIndex = window.popularindexing || [];

  const oneTimePopularIndex = Number(popularIndex[0] ?? -1);
  const monthlyPopularIndex = Number(popularIndex[1] ?? -1);

  $(".Givonate-Widget-amount").each(function (index) {
    const $btn = $(this);

    if ($btn.data("label-added")) return;
    $btn.data("label-added", true);

    const labelText = labels[index] || "";

    const isOneTime = index >= 0 && index <= 3;
    const isMonthly = index >= 4 && index <= 7;

    const monthlyRelativeIndex = index - 4;

    let isPopular = false;

    if (isOneTime && index === oneTimePopularIndex) {
      isPopular = true;
    }

    if (isMonthly && monthlyRelativeIndex === monthlyPopularIndex) {
      isPopular = true;
    }

    if (isPopular) {
      $btn.addClass("popular");

      if (isMonthly) {
        $btn.addClass("popular-monthly");
      } else {
        $btn.addClass("popular-one-time");
      }
    }

    if (labelText || isPopular) {
      const groupClass = isMonthly ? "monthly" : "one-time";

      $btn.append(`
      <div class="label_wrapper custom">
        ${isPopular ? `<span class="label_status ${groupClass}">Popular</span>` : ""}
        <span class="label hidden">${labelText}</span>
      </div>
    `);
    }
  });

  const amountButtons = document.querySelectorAll(".Givonate-Widget-amount");
  const toggleBtns = document.querySelectorAll(".toggle_btn");
  const slideBg = document.querySelector(".slide-bg");

  if (!amountButtons.length) return;

  const oneTimeBtns = Array.from(amountButtons).slice(0, 4);
  const monthlyBtns = Array.from(amountButtons).slice(4, 8);

  monthlyBtns.forEach((btn) => (btn.style.display = "none"));

  toggleBtns.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      toggleBtns.forEach((b) => b.classList.remove("toggle_btn_active"));
      btn.classList.add("toggle_btn_active");

      if (index === 0) {
        // ONE TIME
        oneTimeBtns.forEach((b) => (b.style.display = ""));
        monthlyBtns.forEach((b) => (b.style.display = "none"));
      } else {
        // MONTHLY
        oneTimeBtns.forEach((b) => (b.style.display = "none"));
        monthlyBtns.forEach((b) => (b.style.display = ""));
      }
    });
  });

  toggleBtns.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      slideBg.style.transform =
        index === 0 ? "translateX(0%)" : "translateX(100%)";
      const checkbox = document.querySelector(".Givonate-Checkbox-input");

      if (checkbox) {
        if (index === 0) {
          checkbox.checked = false;
          const popularOneTimeLabel = document.querySelector(
            ".Givonate-Widget-amount .label_status.one-time",
          );
          if (popularOneTimeLabel) {
            const popularOneTimeBtn = popularOneTimeLabel.closest(
              ".Givonate-Widget-amount",
            );
            if (popularOneTimeBtn) popularOneTimeBtn.click();
          }
        } else {
          checkbox.checked = true;
          if (currentPageId == 155838120243) {
            checkbox.checked = false;
          }
          const popularMonthlyLabel = document.querySelector(
            ".Givonate-Widget-amount .label_status.monthly",
          );
          if (popularMonthlyLabel) {
            const popularMonthlyBtn = popularMonthlyLabel.closest(
              ".Givonate-Widget-amount",
            );
            if (popularMonthlyBtn) popularMonthlyBtn.click();
          }
        }

        checkbox.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      }
    });
  });

  function appendActiveLabel(gridSelector = ".Givonate-Widget-grid") {
    // Select the grid
    const grid = document.querySelector(gridSelector);
    if (!grid) return;

    // Remove existing appended label if present
    const existingLabel = grid.nextElementSibling;
    if (
      existingLabel &&
      existingLabel.classList.contains("active-label-text")
    ) {
      existingLabel.remove();
    }

    // Find the active button
    const activeBtn = grid.querySelector(".Givonate-Widget-amount-active");
    if (!activeBtn) return;

    // Get the hidden label text
    const labelText = activeBtn.querySelector(".label")?.textContent.trim();
    if (!labelText) return;

    // Create a new element to append
    const labelDiv = document.createElement("div");
    labelDiv.className = "active-label-text";
    labelDiv.textContent = labelText;

    // Append after the grid
    grid.insertAdjacentElement("afterend", labelDiv);
  }

  // Attach click events to update active label dynamically
  document.querySelectorAll(".Givonate-Widget-amount").forEach((button) => {
    button.addEventListener("click", function () {
      // Remove active class from all buttons in the same grid
      const grid = button.closest(".Givonate-Widget-grid");
      grid
        .querySelectorAll(".Givonate-Widget-amount")
        .forEach((btn) =>
          btn.classList.remove("Givonate-Widget-amount-active"),
        );

      // Add active class to clicked button
      button.classList.add("Givonate-Widget-amount-active");

      // Update the appended label
      appendActiveLabel();
    });
  });

  // Example usage
  appendActiveLabel(); // will append for the default grid

  $(document).ready(function () {
    const $wrapper = $("<div>", {
      class: "custom-amount-wrapper",
    });
    const $customInput = $("<input>", {
      type: "number",
      class: "custom-amount-input",
      placeholder: "£ Enter a Custom Amount",
      min: 1,
      step: 1,
    });

    $wrapper.append($customInput);
    $(".Givonate-Widget-input").after($wrapper);

    /* ------------------------------
           Update URL Parameter
        ------------------------------ */

    function updateAmountInURL(amount) {
      const url = new URL(window.location.href);

      if (amount && amount > 0) {
        url.searchParams.set("amount", amount);
      } else {
        url.searchParams.delete("amount");
      }

      window.history.replaceState({}, "", url);
    }

    /* ------------------------------
           Get amount from URL
        ------------------------------ */

    function getAmountFromURL() {
      const params = new URLSearchParams(window.location.search);
      let amount = parseInt(params.get("amount"), 10);

      if (!isNaN(amount) && amount > 0) {
        return amount;
      }
      return null;
    }

    const urlAmount = getAmountFromURL();

    if (urlAmount) {
      $customInput.val(urlAmount);

      const widgetInput = $(".Givonate-Widget-input input")[0];
      if (widgetInput) {
        widgetInput.value = urlAmount;
        widgetInput.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );
        widgetInput.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      }
    }

    /* ------------------------------
           Sync manual typing
        ------------------------------ */

    $(document).on("input", ".custom-amount-input", function () {
      let value = Math.floor(parseFloat($(this).val()));

      if (isNaN(value) || value < 1) {
        $(this).val("");
        updateAmountInURL(null);
        return;
      }

      $(this).val(value);

      const input = $(".Givonate-Widget-input input")[0];
      if (input) {
        input.value = value;
        input.dispatchEvent(
          new Event("input", {
            bubbles: true,
          }),
        );
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      }

      updateAmountInURL(value);
    });

    /* ------------------------------
           Preset amount click
        ------------------------------ */

    $(document).on("click", ".Givonate-Widget-amount", function () {
      const amount =
        $(this).data("amount") ||
        parseInt($(this).text().replace(/\D/g, ""), 10);

      // if (!isNaN(amount) && amount > 0) {
      //   updateAmountInURL(amount);
      // }
      updateAmountInURL(null);
      $customInput.val("");
    });
  });

  if (currentPageId == 155819049267) {
    $(".toggle_btn.monthlybtn").click();
  }

  console.log("run end");
}

function waitForWidget(callback) {
  const targetSelector = ".Givonate-Widget-amounts";

  // If already exists → run immediately
  if (document.querySelector(targetSelector)) {
    callback();
    return;
  }

  // Otherwise observe DOM changes
  const observer = new MutationObserver(() => {
    if (document.querySelector(targetSelector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

waitForWidget(() => {
  initBannerScripts();
});

// added for ai zakart session
(function () {
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      session: params.get("session"),
      amount: params.get("amount"),
    };
  }

  async function saveSessionToCart(session, amount) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            donation_session: session,
            donation_amount: amount,
          },
        }),
      });

      const result = await response.json();
      console.log("Cart updated:", result);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", async function () {
    const { session, amount } = getUrlParams();

    if (!session) {
      console.log("No session found in URL");
      return;
    }

    console.log("Saving session immediately:", session);

    await saveSessionToCart(session, amount);
  });
})();
